(function () {
  'use strict';
  if (window.__meSizeChartUnitSwitcherLoaded) return;
  window.__meSizeChartUnitSwitcherLoaded = true;
  var style = document.createElement('style');
  style.textContent = ".me-size-chart-unit-controls{display:flex;align-items:center;justify-content:flex-end;gap:7px;margin:0 0 14px;line-height:1.3}\n.me-size-chart-unit-controls[hidden]{display:none!important}\n.me-size-chart-unit-controls .me-size-chart-unit-label{margin-right:5px;font-size:13px}\n.me-size-chart-unit-controls button{min-height:34px;padding:5px 12px;border:1px solid #bdbdbd;border-radius:6px;color:inherit;background:transparent;cursor:pointer;font-size:13px}\n.me-size-chart-unit-controls button[aria-pressed=\"true\"]{background:#272727;color:#fff;border-color:#272727;font-weight:600}\n.me-size-chart-unit-controls button:focus-visible{outline:2px solid currentColor;outline-offset:2px}\nsize-chart-popup .size-chart-content{overflow-x:auto;max-width:100%}";
  document.head.appendChild(style);

  function numberValue(raw) {
    return parseFloat(String(raw).replace(',', '.'));
  }

  function collectCells(table) {
    var entries = [];
    var rows = table.querySelectorAll('tr');
    rows.forEach(function (row) {
      if (row.closest('thead')) return;
      var cells = Array.from(row.children).filter(function (el) {
        return el.matches('td,th');
      });
      var headings = Array.from(table.querySelectorAll('thead tr:last-child th,thead tr:last-child td'));
      cells.forEach(function (cell, index) {
        if (index === 0) return;
        var heading = headings[index] ? headings[index].textContent.trim() : '';
        if (/weight|lbs?|kg|age|shoe/i.test(heading)) return;
        if (cell.querySelector('img,svg,table,input')) return;
        var value = cell.textContent.trim().replace(/\u00a0/g, ' ');
        var matched = value.match(/^(\d+(?:[.,]\d+)?)(\s*(?:-|–|—|~|to)\s*(\d+(?:[.,]\d+)?))?\s*(cm|in|inches|\")?$/i);
        if (!matched) return;
        entries.push({cell:cell, original:value, first:numberValue(matched[1]), second:matched[3] ? numberValue(matched[3]) : null, separator:matched[2] ? (matched[2].match(/[-–—~]/) || ['–'])[0] : null, explicit:matched[4] || ''});
      });
    });
    return entries;
  }

  function setup(popup) {
    if (popup.dataset.meSizeChartInitialized === 'true') return;
    popup.dataset.meSizeChartInitialized = 'true';
    var control = popup.querySelector('[data-size-chart-unit-controls]');
    var content = popup.querySelector('.size-chart-content');
    if (!control || !content) return;
    var tables = Array.from(content.querySelectorAll('table'));
    var entries = [];
    tables.forEach(function (table) { entries.push.apply(entries, collectCells(table)); });
    if (!entries.length) return;
    var originalUnit = popup.dataset.sizeChartOriginalUnit === 'cm' ? 'cm' : 'in';
    var initialUnit = popup.dataset.sizeChartDefaultUnit === 'cm' ? 'cm' : 'in';
    var headings = Array.from(content.querySelectorAll('table thead th,table thead td')).map(function (cell) {
      return {cell:cell,original:cell.textContent.trim()};
    });
    function converted(n,unit) {
      return (unit === 'cm' ? (originalUnit === 'cm' ? n : n * 2.54) : (originalUnit === 'in' ? n : n / 2.54)).toFixed(1);
    }
    function apply(unit) {
      entries.forEach(function (entry) {
        if (unit === originalUnit) {
          entry.cell.textContent = entry.original;
          return;
        }
        var first = converted(entry.first,unit);
        var val = entry.second === null ? first : first + (entry.separator || '–') + converted(entry.second,unit);
        entry.cell.textContent = val;
      });
      headings.forEach(function (entry) {
        var label = entry.original.replace(/\((?:cm|in|inches)\)/gi,'(' + unit + ')');
        if (!/\((?:cm|in|inches)\)/i.test(entry.original) && /^(fit range|length|sleeve|shoulder|bust|chest|waist|hips?)(?:\b|$)/i.test(entry.original)) {
          label += ' (' + unit + ')';
        }
        entry.cell.textContent = label;
      });
      control.querySelectorAll('[data-size-chart-unit]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.sizeChartUnit === unit));
      });
    }
    popup.__meApplySizeChartUnit = apply;
    control.hidden = false;
    apply(initialUnit);
  }
  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches('size-chart-popup')) setup(node);
    if (node.querySelectorAll) node.querySelectorAll('size-chart-popup').forEach(setup);
  }
  document.addEventListener('click',function (event) {
    var button = event.target.closest('[data-size-chart-unit]');
    if (!button) return;
    var popup = button.closest('size-chart-popup');
    if (popup && popup.__meApplySizeChartUnit) {
      event.preventDefault();
      popup.__meApplySizeChartUnit(button.dataset.sizeChartUnit);
    }
  });
  function initialize() {
    scan(document.body);
    var observer = new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        change.addedNodes.forEach(scan);
      });
    });
    observer.observe(document.body,{childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize);
  else initialize();
})();
